<template>
  <div>
    <table-positions-component :data="positions" :placeholder="placeholder" />
    <table-orders-component :data="orders" :placeholder="placeholder" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import TableOrdersComponent from "./history/table-orders.component.vue";
import TablePositionsComponent from "./history/table-positions.component.vue";

export default {
  components: {
    TablePositionsComponent,
    TableOrdersComponent,
  },

  data() {
    return {
      positions: { investments: [] },
      orders: { investments: [] },
      placeholder: false,
    };
  },

  computed: {
    ...mapState({
      selectedAccount: (state) => state.accountTypes.selectedAccount,
    }),
  },

  methods: {
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 0.5,
        scale: 0.9,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.3, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.3, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.3,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    getHistory(value) {
      this.placeholder = true;
      this.$api
        .get(`${this.$endpoint.INVESTMENTS_HISTORY}/${value.account_id}`)
        .then((response) => {
          this.positions.investments = response.data.positions.investments;
          this.orders.investments = response.data.orders.investments;
        })
        .finally(() => {
          this.placeholder = false;
        });
    },

    // --> NÃO ESTÁ SENDO UTILIZADA
    //
    // showInvestmentPortfolio(inv) {
    //   const index = this.toogle.indexOf(inv);
    //   if (index > -1) {
    //     this.toogle.splice(index, 1);
    //   } else {
    //     this.toogle.push(inv);
    //   }
    // },
  },

  watch: {
    selectedAccount: {
      immediate: true,
      handler(value) {
        this.getHistory(value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.title_th {
  @apply px-3 py-2 text-center text-sm font-medium  text-ontick-steel-900 dark:text-gray-300;
}
.td-items {
  @apply whitespace-nowrap px-3 py-3 text-center text-xs text-ontick-steel-900 dark:text-gray-300;
}
</style>
